import { ReservierungNeu, IdRequest, RemoteResult } from "mangdto"
import BaseLogic from "../base_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"

export default class ReservierungLogic extends BaseLogic {
  reservierung: ReservierungNeu

  init(id: string) {
    var request = new IdRequest()
    request.id = id

    Poster.postUser<RemoteResult<ReservierungNeu>>(
      RestPaths.reservierungenDetailsKunde,
      request,
    ).then((response) => {
      this.mainLogic.reservierung = response.data.payload
    })
  }
}
